<template>
    <form @submit.prevent="submitForm">
        <div class="login-form">
            <input name="login" :placeholder="$t('login.identifiant.placeholder')" type="text" v-model="login" required/>
            <div class="password-area" v-if='oldLogin'>
                <input name="password" :placeholder="$t('login.password.placeholder')" :type="showPassword ? 'text' : 'password'" v-model="password" @keyup.enter="submitForm" required/>
                <img :src="loadEyeIcon" @click="toggleShow()" alt="Voir le mot de passe">
            </div>
            <p class="account" @click="modaleDemandeCompteOuverte = true">{{$t('login.account.link')}}</p>
            <p class="account" @click="modaleDemandeFournisseurCompteOuverte = true">{{$t('login.account.fournisseur.link')}}</p>
            <button class="form-submit-button" type="submit" :disabled="!isComplete">{{$t('login.connect')}}</button>
        </div>
    </form>
    <Modal v-if='demandeCompteClientSucces || demandeCompteFournisseurSucces' @cancel='closeModalSuccess'>
        <ModalCard :active-validate="true" :without-bot-nav='true' :header-title="$t('demande.compte.envoye.titre.modale')" @cancel='closeModalSuccess'>
            <img :src='checkBoxIcon' alt=''>
            <div v-if='demandeCompteClientSucces'>{{$t('demande.compte.client.message.succes')}}</div>
            <div v-if='demandeCompteFournisseurSucces'>{{$t('demande.compte.fournisseur.message.succes')}}</div>
        </ModalCard>
    </Modal>
    <Modal v-if='modaleDemandeCompteOuverte' @cancel='modaleDemandeCompteOuverte = false'>
        <ModalCard
            :active-validate="demandeCompteValide"
            :header-title="$t('demande.creation.compte.modal.titre')"
            @cancel='modaleDemandeCompteOuverte = false'
            @confirm='creerDemandeDeCompte'>
            <form>
                <div class='titre-modale'>{{$t('demande.creation.compte.modal.coordonnees')}}</div>
                <div class='div-input-modale'>
                    <input name="nomModale" :placeholder="$t('demande.creation.compte.modal.nom')" type="text" v-model="nomModale" required class='input-modale'/>
                </div>
                <div class='div-input-modale'>
                    <input name="prenomModale" :placeholder="$t('demande.creation.compte.modal.prenom')" type="text" v-model="prenomModale" required class='input-modale'/>
                </div>
                <div class='div-input-modale'>
                    <input name="emailModale" :placeholder="$t('demande.creation.compte.modal.mail')" type="text" v-model="emailModale" required :class="!isMailValid ? 'no-valid' : 'input-modale'"/>
                </div>
                <div class='div-input-modale'>
                    <input name="entrepriseModale" :placeholder="$t('demande.creation.compte.modal.entreprise')" type="text" v-model="entrepriseModale" required class='input-modale'/>
                </div>
                <div class='div-input-modale'>
                    <input name="numeroTelephoneModale" :placeholder="$t('demande.creation.compte.modal.telephone')" maxlength='10' type="number" v-model="numeroTelephoneModale" required :class="!isTelephoneValid ? 'no-valid' : 'input-modale'"/>
                </div>
            </form>
        </ModalCard>
    </Modal>

    <Modal v-if='modaleDemandeFournisseurCompteOuverte' @cancel='modaleDemandeFournisseurCompteOuverte = false'>
        <ModalCard
            :active-validate="demandeCompteFournisseurValide"
            :header-title="$t('demande.creation.compte.modal.titre')"
            @cancel='modaleDemandeFournisseurCompteOuverte = false'
            @confirm='creerDemandeDeCompteFournisseur'>
            <form class='text-left margin-left-4pct'>
                <div class='italique bold'>{{$t('demande.compte.fournisseur.texte.italique')}}</div>
                <ul>
                    <li class='italique bold'>{{$t('demande.compte.fournisseur.ul.1')}}</li>
                    <li class='italique bold'>{{$t('demande.compte.fournisseur.ul.2')}}</li>
                </ul>

                <div class='bold'>{{$t('demande.compte.fournisseur.texte.gras')}}</div>

                <div class='titre-formulaire-bleu bold'>{{$t('demande.compte.fournisseur.form.coordonees')}}</div>

                <div class='flex'>
                    <div class='column width-50pct'>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.societe.nom')" type="text" v-model="demandeFournisseur.nomSociete" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.siren')" type="text" v-model="demandeFournisseur.siren" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.nom')" type="text" v-model="demandeFournisseur.nom" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.mail')" type="text" v-model="demandeFournisseur.email" required class='input'/>
                    </div>
                    <div class='column width-50pct'>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.ville')" type="text" v-model="demandeFournisseur.ville" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.civilite')" type="text" v-model="demandeFournisseur.civilite" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.prenom')" type="text" v-model="demandeFournisseur.prenom" required class='input'/>
                        <input name="nomSociete" :placeholder="$t('demande.compte.fournisseur.form.placeholder.fonction')" type="text" v-model="demandeFournisseur.fonction" required class='input'/>
                    </div>
                </div>

                <div class='titre-formulaire-bleu bold '>{{$t('demande.compte.fournisseur.form.souhait')}}</div>

                <div>{{$t('demande.compte.fournisseur.form.consultation.factures')}}</div>
                <input type='radio' v-model='demandeFournisseur.consultationFactures' :value="true">{{$t('yes')}}
                <input type='radio' v-model='demandeFournisseur.consultationFactures' :value="false">{{$t('no')}}
                <br>
                <br>
                <input type='checkbox' v-model='conditionsGeneralesAcceptees'>
                <a href="https://www.groupeherve.com/cgu.html" target='_blank'>{{$t('demande.compte.fournisseur.form.condition.utilisation')}}</a>
                <br>
                <br>
                <div>{{$t('demande.compte.fournisseur.form.champs.obligatoires')}}</div>
            </form>
        </ModalCard>
    </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { AuthenticationParameters, CreationCompteParametres } from '@/modules/Auth/store/state';
import Modal from '@/components/ui-components/Modal.vue';
import ModalCard from '@/components/ui-components/ModalCard.vue';
import regex from '@/common/utils/Regex';
import loginService from '@/modules/Login/services/LoginService';
import ErrorManager from '@/common/utils/ErrorManager';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';

export default defineComponent({
    name: 'LoginForm.vue',
    emits: ['data-login', 'creer-compte'],
    components: { ModalCard, Modal },
    data(){
        return {
            password: '',
            login: '',
            showPassword: false,
            modaleDemandeCompteOuverte: false,
            modaleDemandeFournisseurCompteOuverte: false,
            nomModale: '',
            prenomModale: '',
            emailModale: '',
            entrepriseModale: '',
            numeroTelephoneModale: undefined,
            conditionsGeneralesAcceptees: false,
            demandeCompteClientSucces: false,
            demandeCompteFournisseurSucces: false,
            demandeFournisseur: {
                nomSociete: '',
                nom: '',
                prenom: '',
                email: '',
                ville: '',
                civilite: '',
                fonction: '',
                siren: '',
                consultationFactures: undefined,
            }
        };
    },
    props: {
        oldLogin: {type: Boolean, required: true}
    },
    computed: {
        checkBoxIcon() {
            return require('@/assets/img/valid2.svg');
        },
        loadEyeIcon(){
            if(this.showPassword){
                return require('@/assets/img/eye.svg');
            }else{
                return require('@/assets/img/eyeOff.svg');
            }
        },
        isComplete(): boolean {
            //on vérifie que l'utilisateur ne tente pas de saisir un formulaire vide
            // return (this.password.trim() !== '' && this.login.trim() !== '');

            return this.login.trim() !== '';
        },
        demandeCompteValide() : boolean {
            return this.nomModale.trim() !== '' && this.prenomModale.trim() !== '' && this.entrepriseModale.trim() !== ''
                && this.emailModale.trim() !== '' && this.isMailValid && this.isTelephoneValid;
        },
        demandeCompteFournisseurValide() : boolean {
            return this.demandeFournisseur.nomSociete.trim() !== '' && this.demandeFournisseur.ville.trim() !== '' && this.demandeFournisseur.siren.trim() !== ''
                && this.demandeFournisseur.nom.trim() !== '' && this.demandeFournisseur.prenom.trim() !== '' && this.isMailFournisseurValid
                && this.demandeFournisseur.fonction !== '' && this.demandeFournisseur.consultationFactures != null && this.conditionsGeneralesAcceptees;
        },
        isMailValid() : boolean {
            return this.emailModale === '' || regex.mail().test(this.emailModale);
        },
        isMailFournisseurValid() : boolean {
            return this.demandeFournisseur.email.trim()  !== '' && regex.mail().test(this.demandeFournisseur.email);
        },
        isTelephoneValid(): boolean {
            return this.numeroTelephoneModale === undefined || regex.telephone().test(this.numeroTelephoneModale !== undefined ? this.numeroTelephoneModale : '');
        },
    },
    methods: {
        closeModalSuccess() {
            this.demandeCompteFournisseurSucces = false;
            this.demandeCompteClientSucces = false;
        },
        toggleShow(){
            this.showPassword = !this.showPassword;
        },
        submitForm() {
            if(this.isComplete){
                //On envoie les informations au composant parent pour l'authentification
                const data: AuthenticationParameters = {
                    login : this.login,
                    password: this.password
                };
                this.$emit('data-login', data);
            }
        },
        creerDemandeDeCompte() {
            const data : CreationCompteParametres = {
                nom: this.nomModale,
                prenom: this.prenomModale,
                mail: this.emailModale,
                entreprise: this.entrepriseModale,
                numeroTelephone: this.numeroTelephoneModale
            } ;
            loginService.demanderCreationCompte(data)
                .then(() => {
                    this.demandeCompteClientSucces = true;
                    this.resetData();
                })
                .catch(async (err: any) => {
                    const message = await ErrorManager.processError(err.response);

                    this.$store.commit(`errorToaster/${ERROR.SET_ACTIVE}`, true);
                    this.$store.commit(`errorToaster/${ERROR.SET_MESSAGE}`, message);
                });
            this.modaleDemandeCompteOuverte = false;
        },
        resetData() {
            this.nomModale = '';
            this.prenomModale = '';
            this.emailModale = '';
            this.entrepriseModale = '';
            this.numeroTelephoneModale = undefined;
        },
        creerDemandeDeCompteFournisseur() {
            const data : CreationCompteParametres = {
                nom: this.demandeFournisseur.nom,
                prenom: this.demandeFournisseur.prenom,
                mail: this.demandeFournisseur.email,
                siren: this.demandeFournisseur.siren,
                nomSociete: this.demandeFournisseur.nomSociete,
                ville: this.demandeFournisseur.ville,
                civilite: this.demandeFournisseur.civilite,
                fonction: this.demandeFournisseur.fonction,
                consultationFactures: this.demandeFournisseur.consultationFactures,
            } ;
            loginService.demanderCreationCompteFournisseur(data)
                .then(() => {
                    this.demandeCompteFournisseurSucces = true;
                    this.resetDataFournisseur();
                })
                .catch(async (err: any) => {
                    const message = await ErrorManager.processError(err.response);

                    this.$store.commit(`errorToaster/${ERROR.SET_ACTIVE}`, true);
                    this.$store.commit(`errorToaster/${ERROR.SET_MESSAGE}`, message);
                });
            this.modaleDemandeFournisseurCompteOuverte = false;
        },
        resetDataFournisseur() {
            this.demandeFournisseur = {
                nomSociete: '',
                nom: '',
                prenom: '',
                email: '',
                ville: '',
                civilite: '',
                fonction: '',
                siren: '',
                consultationFactures: undefined,
            };
        }
    }
});
</script>

<style scoped>
.login-form input{
    height: 4.5vh;
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.38);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    margin: 10px 0;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
}
.password-area{
    display: flex;
}
.password-area input{
    margin-bottom: 6px;
}
.password-area img{
    margin-left: -30px;
    cursor: pointer;
    height: fit-content;
    align-self: center;
    margin-top: 4px;
}
.form-submit-button{
    height: 6vh;
    background: var(--light-green);
    border-radius: 4px;
    padding: 0 32px;
    font-size: var(--font-size-small);
    line-height: var(--line-spacing-very-small);
    font-weight: var(--font-weight-bold);
    color: var(--white);
    letter-spacing: 0.009em;
    width: fit-content;
    border: none;
    margin-top: 20px;
    cursor: pointer;
}
.form-submit-button:disabled{
    background: var(--background-color-disabled);
    color: var(--text-color-disabled);
    cursor: default;
}
.account {
    font-weight: var(--font-weight-300);
    font-size: var(--font-size-very-small);
    font-style: var(--font-style-normal);
    line-height: var(--line-spacing-small);
    text-decoration-line: underline;
    padding-top: 0;
    width: fit-content;
    cursor: pointer;
}
.div-input-modale {
    width: 30vw;
    height: 25px;
    margin: 10px;
}
.input-modale {
    width: 90%;
    height: 100%;
    border: 1px solid rgba(0, 0, 0, 0.38);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
}
.titre-modale {
    text-align: left;
    margin-left: 7%;
}
.no-valid {
    border: 1px solid var(--red) !important;
    width: 90%;
    height: 100%;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: var(--font-size-low-medium);
}
.titre-formulaire-bleu {
    color: var(--bleu-prinicipal);
    text-align: left;
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 20px;
}
.input {
    width: 90%;
    height: 25px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    box-sizing: border-box;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: var(--font-size-low-medium);
    color: var(--color-principal);
}
.margin-left-4pct {
    margin-left: 4%;
}
</style>
